module.exports = "<app-toolbar></app-toolbar>\n<main role=\"main\">\n  <router-outlet></router-outlet>\n</main>\n<app-footer></app-footer>"